import React from 'react'

import Logo from '@/app/component/atom/logo'
import { Organization, SelectOption } from '@/app/types'

import AccountMenu from './account-menu'
import { Content, Right, StyledLink } from './common'
import { catiAccountNavMap } from './definitions'

type Props = {
  activeOrg?: Organization
  currentPage: string
  email: string
  organizations?: SelectOption<number>[]
  isAuthorized: boolean
  hasOrg: boolean
  accountMenuOpen: boolean
  panelExpanded: boolean
  onAccountMenuToggle: () => void
  onOrganizationChange: (org: SelectOption<number>) => void
  onPanelToggle: () => void
  logout: () => void
}

const CATIDesktopHeader: React.FC<Props> = ({
  activeOrg,
  currentPage,
  email,
  organizations = [],
  isAuthorized,
  hasOrg,
  accountMenuOpen,
  panelExpanded,
  onAccountMenuToggle,
  onOrganizationChange,
  onPanelToggle,
  logout,
}) => (
  <>
    <StyledLink to="/">
      <Logo />
    </StyledLink>
    <Content>
      <Right>
        {isAuthorized && (
          <AccountMenu
            activeOrg={activeOrg}
            currentPage={currentPage}
            email={email}
            hasOrg={hasOrg}
            menuOpen={accountMenuOpen}
            navItems={catiAccountNavMap}
            organizations={organizations}
            panelExpanded={panelExpanded}
            onLogoutClick={logout}
            onMenuToggle={onAccountMenuToggle}
            onOrganizationChange={onOrganizationChange}
            onPanelToggle={onPanelToggle}
          />
        )}
      </Right>
    </Content>
  </>
)

export default CATIDesktopHeader
